// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-medium":"#5e5e5e","grey-light":"#c9c9c9","text":"nZ0IPnh"};